import React from "react";
import "../assets/styles/pages/education.css";
import cvutLogo from "../assets/images/logo_cvut.svg";
import { useInView } from "react-intersection-observer";
import { useIntersectionThreshold } from "../hooks/useIntersectionThreshold";

function Education() {
    const threshold = useIntersectionThreshold();

    const [ref1, inView1] = useInView({ threshold, triggerOnce: true });
    const [ref2, inView2] = useInView({ threshold, triggerOnce: true });

    return (
        <section id="education" className="education section bg-raised" aria-labelledby="education-title">
            <div className="shell">
                <header className="section__header">
                    <p className="section__eyebrow">Academic credentials</p>
                    <h2 id="education-title" className="section__title">
                        Education
                    </h2>
                    <p className="section__lead">
                        Engineering degrees from CTU Prague, Faculty of Information Technology — rigorous training in
                        computer science and software engineering.
                    </p>
                </header>

                <div className="card-stack">
                    <article
                        ref={ref1}
                        className={`timeline-card reveal${inView1 ? " is-visible" : ""}`}
                    >
                        <div className="timeline-card__top">
                            <div className="timeline-card__brand">
                                <a
                                    className="timeline-card__logo-link"
                                    href="https://fit.cvut.cz/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Faculty of Information Technology, CTU Prague"
                                >
                                    <img
                                        src={cvutLogo}
                                        className="timeline-card__logo img-cvut-logo"
                                        alt=""
                                        height={40}
                                        width={40}
                                    />
                                </a>
                                <h3 className="timeline-card__title">
                                    <a href="https://fit.cvut.cz/" target="_blank" rel="noopener noreferrer">
                                        Bc. Software Engineering
                                    </a>
                                </h3>
                            </div>
                            <span className="timeline-card__meta">Sep 2020 – Jun 2023</span>
                        </div>
                        <div className="timeline-card__body">
                            <p>
                                Completed a Bachelor&apos;s degree in Software Engineering with a rigorous core in
                                algorithms, data structures, software architecture, and systems design. Coursework and
                                capstone projects emphasized engineering discipline, code quality, and delivering
                                maintainable applications in team settings.
                            </p>
                            <p className="timeline-card__tagline">
                                Czech Technical University in Prague · Faculty of Information Technology
                            </p>
                        </div>
                    </article>

                    <article
                        ref={ref2}
                        className={`timeline-card reveal${inView2 ? " is-visible" : ""}`}
                    >
                        <div className="timeline-card__top">
                            <div className="timeline-card__brand">
                                <a
                                    className="timeline-card__logo-link"
                                    href="https://fit.cvut.cz/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Faculty of Information Technology, CTU Prague"
                                >
                                    <img
                                        src={cvutLogo}
                                        className="timeline-card__logo img-cvut-logo"
                                        alt=""
                                        height={40}
                                        width={40}
                                    />
                                </a>
                                <h3 className="timeline-card__title">
                                    <a href="https://fit.cvut.cz/" target="_blank" rel="noopener noreferrer">
                                        Ing. Managerial Informatics
                                    </a>
                                </h3>
                            </div>
                            <span className="timeline-card__meta">Sep 2023 – Jun 2025</span>
                        </div>
                        <div className="timeline-card__body">
                            <p>
                                Earned an Ing. (Master&apos;s-level engineering) degree in Managerial Informatics,
                                extending technical depth with enterprise information systems, data-driven analysis, and
                                IT governance. The program strengthened my ability to translate complex requirements
                                into reliable solutions aligned with organizational goals.
                            </p>
                            <p className="timeline-card__tagline">
                                Czech Technical University in Prague · Faculty of Information Technology
                            </p>
                        </div>
                    </article>
                </div>
            </div>
        </section>
    );
}

export default Education;
